<script lang="ts" setup>
const props = defineProps<{
  status: 'error' | 'info' | 'warning';
  text: string;
}>();
</script>

<template>
  <div :class="['badge', props.status]">
    {{ props.text }}
  </div>
</template>

<style lang="scss" scoped>
.badge {
  padding: 6px 12px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 40px;
}

.info {
  background: $ui-background-info-light;
  color: $ui-info;
}

.warning {
  background: $ui-background-warn-light;
  color: $ui-warning;
}

.error {
  background: $ui-background-error-light;
  color: $ui-error;
}
</style>
